import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICE_PROVIDER_LOADING = 'GET_INVOICE_PROVIDER_LOADING';
export const GET_INVOICE_PROVIDER_SUCCESS = 'GET_INVOICE_PROVIDER_SUCCESS';
export const GET_INVOICE_PROVIDER_REJECT = 'GET_INVOICE_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const getInvoiceProviderLoading = () => ({ type: GET_INVOICE_PROVIDER_LOADING });
export const getInvoiceProviderSuccess = (payload) => ({ type: GET_INVOICE_PROVIDER_SUCCESS, payload });
export const getInvoiceProviderReject = (payload) => ({ type: GET_INVOICE_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getInvoiceProviderRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/ProvidersBillingTracking/web/GetAllProvidersBillingTracking`, options);
};

